export var BUSINESS_BOOKER_USER_ROLES = Object.freeze({
  SUPER: 'SUPER',
  BOOKER: 'BOOKER',
  SELF: 'SELF',
  STAYER: 'STAYER',
  BUSINESS_PAY_MANAGER: 'BUSINESS_PAY_MANAGER',
  BUSINESS_PAY_USER: 'BUSINESS_PAY_USER'
});